{
  "R": [0, 0, 24, 248, 255],
  "G": [0, 0, 177, 254, 0],
  "B": [0, 136, 0, 0, 0],
  "A": [0, 32, 64, 78, 128],
  "I": [0, 64, 128, 156, 255]
}
